import type { FunctionComponent } from 'react'

import { GamPanel } from '../../../../shared'
import { usePageGamConfig } from '../../../../shared/hooks/usePageGamConfig'
import type { PageInfo } from '../../../../shared/types'

type Props = { pageInfo: PageInfo }

export const ArticlePageBodyGam: FunctionComponent<Props> = ({ pageInfo }) => {
  const gamConfig = usePageGamConfig({ pageInfo })

  if (gamConfig === undefined) {
    return null
  }

  return (
    <div>
      <GamPanel
        {...gamConfig}
        gamId="div-gpt-ad-6221233-1"
        panelName="articleBody"
        sizeMappings={[
          [[1270, 0], [[600, 250]]],
          [[375, 0], [[300, 250]]],
          [[0, 0], []],
        ]}
      />
      <GamPanel
        {...gamConfig}
        gamId="div-gpt-ad-6221233-2"
        panelName="articleBodyOutOfPage"
        pos="acquisition_banner"
        isOOP={true}
      />
      <GamPanel
        {...gamConfig}
        gamId="div-gpt-ad-6221233-3"
        panelName="articleBodyOutOfPage2"
        pos="pop_up"
        isOOP={true}
      />
    </div>
  )
}
